<template>
  <v-app>
    <Snackbar v-if="renderComp" :SnackBarComponent="SnackBarComponent" />
    <v-app-bar app dense color="white" class="elevation-1">
      <v-img contain max-width="150px" src="@/assets/mpowerlogo.png"></v-img>
    </v-app-bar>
    <v-main class="">
      <v-row align="center" justify="center">
        <v-col cols="9" sm="8" xs="12" md="8" class="" align="center" justify="center">
          <v-card elevation="0" align-center justify-center>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" xs="12" md="12" align="center" justify="center">
                <v-window v-model="loginStepper" class="px-3">
                  <v-card elevation="0">
                    <v-card-text class="mt-10 pa-0" align-center justify-center>
                      <v-img contain class="mb-10" width=" 330px" src="@/assets/magnasoft-logo-master-3.png"></v-img>
                      <v-window-item :value="1">
                        <div class="mb-3">
                          <h2 class="primary--text">Sign In - MPOWER CLOUD</h2>
                        </div>
                        <v-form ref="form" class="mt-3">
                          <v-row align-center justify="center">
                            <v-col class="mt-0 pt-0" cols="12" xs="12" sm="12" md="6">
                              <v-text-field
                                v-model.trim="Login.email"
                                label="Email"
                                outlined
                                dense
                                color="primary"
                                autocomplete="false"
                                class="mt-3 FontSize"
                                :rules="emailRules"
                                required>
                              </v-text-field>
                              <v-text-field
                                class="FontSize"
                                v-model.trim="Login.password"
                                :type="pass ? 'text' : 'password'"
                                :rules="[(v) => !!v || 'Password id required']"
                                label="Password"
                                required
                                outlined
                                dense
                                color="primary"
                                autocomplete="false"
                                :append-icon="pass ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="pass = !pass"
                                @keyup.enter="ValidateMethod()"></v-text-field>
                              <v-row>
                                <v-col cols="12" sm="7">
                                  <v-checkbox dense label="Remember me" class="mt-n1 FontSize" color="primary" v-model="rememberme"></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="5" class="">
                                  <span class="Caption primary--text FontSize" @click="loginStepper = 3">Forgot Password ?</span>
                                </v-col>
                              </v-row>
                              <v-btn color="primary" dark block :loading="loading" @click="ValidateMethod()">Login</v-btn>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-window-item>
                      <v-window-item :value="2">
                        <v-card-text>
                          <v-form ref="formCP" lazy-validation>
                            <div class="mb-3">
                              <h2 class="primary--text">Change Password</h2>
                            </div>
                            <v-row align="center" justify="center">
                              <v-col cols="12" xs="12" sm="12" md="6">
                                <v-text-field
                                  class="fontSize"
                                  outlined
                                  dense
                                  label="Enter New Password *"
                                  :type="isPwdNew ? 'text' : 'password'"
                                  @click:append="isPwdNew = !isPwdNew"
                                  required
                                  :append-icon="isPwdNew ? 'mdi-eye' : 'mdi-eye-off'"
                                  prepend-inner-icon="mdi-lock"
                                  :rules="[(v) => !!v || 'Password is required']"
                                  v-model.trim="Password.NewPassword"></v-text-field>
                                <v-text-field
                                  class="fontSize"
                                  outlined
                                  dense
                                  label="Confirm New Password *"
                                  :type="isPwdConfirm ? 'text' : 'password'"
                                  @click:append="isPwdConfirm = !isPwdConfirm"
                                  required
                                  :append-icon="isPwdConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                                  prepend-inner-icon="mdi-lock"
                                  :rules="[(v) => !!v || 'Password is required']"
                                  v-model.trim="Password.ConfirmPassword"
                                  @keyup.enter="ValidateConfirmPasswordForm()"></v-text-field>
                                <v-card-actions class="pt-0 pb-8">
                                  <v-btn color="primary" dark block rounded-pill :loading="loading" @click="ValidateConfirmPasswordForm()"
                                    >Login</v-btn
                                  >
                                </v-card-actions>
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-card-text>
                      </v-window-item>
                    </v-card-text>
                    <v-window-item :value="3">
                      <v-card-text>
                        <v-row class="mb-6 pa-0" align-center justify="center">
                          <div>
                            <h2 class="primary--text">Forgot Password ?</h2>
                          </div>
                        </v-row>
                        <v-form ref="forgotpass" lazy-validation>
                          <v-row align-center justify="center">
                            <v-col cols="12" xs="12" sm="12" md="6">
                              <v-text-field
                                v-model.trim="OTPEmail"
                                label="Email"
                                outlined
                                dense
                                color="primary"
                                autocomplete="false"
                                class="mt-0 FontSize"
                                :rules="emailRules"
                                required>
                              </v-text-field>

                              <v-card-actions class="pa-0">
                                <v-btn class="ma-0" color="primary" dark block :loading="loading" @click="forgotPasswordMethod">Send OTP</v-btn>
                              </v-card-actions>
                              <v-btn left small block text @click="loginStepper = 1">
                                <v-icon left>mdi-chevron-double-left</v-icon>
                                Back To Login
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-card-text>
                    </v-window-item>
                    <v-window-item :value="4">
                      <v-card-text>
                        <v-row class="mb-6 pa-0" align-center justify="center">
                          <div>
                            <h2 class="primary--text">Confirm OTP and Password</h2>
                          </div>
                        </v-row>
                        <v-form ref="confirmOTP" lazy-validation>
                          <v-row align-center justify="center">
                            <v-col cols="12" xs="12" sm="12" md="6">
                              <v-text-field
                                class="fontSize"
                                outlined
                                dense
                                label="Enter OTP *"
                                required
                                :rules="[(v) => !!v || 'OTP is required']"
                                prepend-inner-icon="mdi-lock-clock"
                                v-model.trim="OTPInput"></v-text-field>
                              <v-text-field
                                class="fontSize"
                                outlined
                                dense
                                label="Enter New Password *"
                                :type="isPwdNew ? 'text' : 'password'"
                                @click:append="isPwdNew = !isPwdNew"
                                required
                                :append-icon="isPwdNew ? 'mdi-eye' : 'mdi-eye-off'"
                                prepend-inner-icon="mdi-lock"
                                :rules="[(v) => !!v || 'Password is required']"
                                v-model.trim="ConfirmNewPassword"></v-text-field>
                              <v-text-field
                                class="fontSize"
                                outlined
                                dense
                                label="Confirm New Password *"
                                :type="isPwdConfirm ? 'text' : 'password'"
                                @click:append="isPwdConfirm = !isPwdConfirm"
                                required
                                :append-icon="isPwdConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                                prepend-inner-icon="mdi-lock"
                                :rules="[(v) => !!v || 'Password is required']"
                                v-model.trim="ReenterNewPassword"></v-text-field>

                              <v-card-actions class="pa-0">
                                <v-btn class="ma-0" color="primary" dark block :loading="loading" @click="ValidateEnteredOTP"> Change Password</v-btn>
                              </v-card-actions>
                              <v-row>
                                <v-col cols="6" align="start" class="green--text">
                                  <v-btn left small text @click="loginStepper = 1">
                                    <v-icon left>mdi-chevron-double-left</v-icon>
                                    Back To Login
                                  </v-btn>
                                </v-col>
                                <v-col cols="6" align="end"
                                  ><v-btn class="primary--text" left small text @click="SendOTPEmail"> Resend OTP </v-btn></v-col
                                >
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-card-text>
                    </v-window-item>
                  </v-card>
                </v-window>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <!-- <div class="supportBtn">
    <v-tooltip top>
     <template v-slot:activator="{ on, attrs }">
      <v-avatar class="supportimage mr-3">
       <v-img
        v-bind="attrs"
        v-on="on"
        src="@/assets/Mpower_Support Logo-01.svg">
       </v-img>
      </v-avatar>
     </template>
     <span>Need Help ?</span>
    </v-tooltip>
   </div> -->
    </v-main>
  </v-app>
</template>
<script>
import { Auth } from "aws-amplify";
import Snackbar from "@/components/Extras/SnackbarVue.vue";
import { GetCurrentUserDetails } from "@/mixins/GetCurrentUser.js";
export default {
  components: {
    Snackbar,
  },
  mixins: [GetCurrentUserDetails],
  data: () => ({
    renderComp: true,
    pass: false,
    loginStepper: 1,
    Password: {
      NewPassword: "",
      ConfirmPassword: "",
    },
    isPwdConfirm: false,
    rememberme: false,
    isPwdNew: false,
    valid: true,
    Login: {
      email: "",
      password: "",
    },
    password: "",
    windowHeight: 0,
    passwordRules: [(v) => !!v || "password is required"],
    email: "",
    emailRules: [(v) => !!v || "Email is required", (v) => /.+@.+\..+/.test(v) || "Email must be valid"],
    SnackBarComponent: {},
    loading: false,
    OTPEmail: "",
    isOtpSent: false,
    OTPInput: "",
    ReenterNewPassword: "",
    ConfirmNewPassword: "",
  }),
  watch: {
    rememberme(val) {
      if (val == true) {
        localStorage.setItem("mpowerclouduserdetails", JSON.stringify(this.Login));
      } else if (val == false) {
        delete localStorage.mpowerclouduserdetails;
      }
    },
  },
  mounted() {
    this.CheckRememberMe();
    this.windowHeight = window.innerHeight - 100;
  },
  methods: {
    async CheckRememberMe() {
      if (localStorage.getItem("mpowerclouduserdetails") != null) {
        this.Login = await JSON.parse(localStorage.getItem("mpowerclouduserdetails"));
        this.rememberme = true;
      }
    },
    signup() {
      this.$refs.form.validate();
    },
    ValidateMethod() {
      if (this.$refs.form.validate()) {
        this.signInMethod();
      } else {
        this.renderComp = false;
        this.$nextTick(() => {
          this.renderComp = true;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Email and password required !.",
          };
        });
      }
    },
    async signInMethod() {
      try {
        this.loading = true;
        const user = await Auth.signIn(this.Login.email.trim(), this.Login.password.trim());
        this.user = user;
        if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          this.loginStepper = 2;
          this.loading = false;
          this.$store.commit("SET_USEREMAIL", this.Login.email);
        } else {
          this.$store.commit("SET_USEREMAIL", this.Login.email);
          this.renderComp = false;
          this.$nextTick(() => {
            this.renderComp = true;
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "green",
              Top: true,
              timeout: 500,
              SnackbarText: "Login Successful",
            };
          });

          await this.GetCurrentUserDetailsMethod();
          this.ActivateMethod();
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        this.renderComp = false;
        this.$nextTick(() => {
          this.renderComp = true;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            timeout: 1000,
            SnackbarText: error.message,
          };
        });
      }
    },
    ActivateMethod() {
      this.renderComp = false;
      this.$nextTick(() => {
        this.renderComp = true;
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "green",
          Top: true,
          SnackbarText: "Login Successful",
        };
      });

      //  this.$store.commit("SET_LOGIN_STATUS", true);
      setTimeout(() => this.$router.push("/Home"), 1000);
    },
    ValidateConfirmPasswordForm() {
      if (this.$refs.formCP.validate()) {
        if (this.Password.NewPassword == this.Password.ConfirmPassword) {
          this.ConfirmPassword();
        } else {
          this.$refs.form.reset();
          this.renderComp = false;
          this.$nextTick(() => {
            this.renderComp = true;
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "red",
              Top: true,
              SnackbarText: "Password does not match",
            };
          });
        }
      } else {
        this.renderComp = false;
        this.$nextTick(() => {
          this.renderComp = true;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Fields marked with asterisks (*) are mandatory",
          };
        });
      }
    },
    async ConfirmPassword() {
      try {
        this.loading = true;
        console.log(this.Password.ConfirmPassword);
        const result = await Auth.completeNewPassword(this.user, this.Password.ConfirmPassword)
          .then((user) => {
            return user;
          })
          .catch((e) => {
            this.renderComp = false;
            this.$nextTick(() => {
              this.renderComp = true;
              this.SnackBarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "red",
                Top: true,
                SnackbarText: e,
              };
            });

            return e;
          });
        if (result.username) {
          this.loading = false;
          this.renderComp = false;
          this.$nextTick(() => {
            this.renderComp = true;
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "green",
              Top: true,
              SnackbarText: "Login Successful",
            };
          });

          this.$refs.formCP.reset();
          this.ActivateMethod();
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.renderComp = false;
        this.$nextTick(() => {
          this.renderComp = true;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: error.message,
          };
        });
      }
    },
    forgotPasswordMethod() {
      if (this.$refs.forgotpass.validate()) {
        this.SendOTPEmail();
      } else {
        this.renderComp = false;
        this.$nextTick(() => {
          this.renderComp = true;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Please Enter Registered Email",
          };
        });
      }
    },
    SendOTPEmail() {
      Auth.forgotPassword(this.OTPEmail)
        .then(() => {
          this.renderComp = false;
          this.$nextTick(() => {
            this.renderComp = true;
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "green",
              Top: true,
              SnackbarText: "OTP Sent To Registered Email",
            };
          });

          this.loginStepper = 4;
        })
        .catch((err) => {
          this.renderComp = false;
          this.$nextTick(() => {
            this.renderComp = true;
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "red",
              Top: true,
              SnackbarText: err.message,
            };
          });
        });
    },
    ValidateEnteredOTP() {
      if (this.$refs.confirmOTP.validate()) {
        if (this.ReenterNewPassword === this.ConfirmNewPassword) {
          this.ConfirmOTPMethod();
        } else {
          this.renderComp = false;
          this.$nextTick(() => {
            this.renderComp = true;
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "red",
              Top: true,
              SnackbarText: "Password Does not match",
            };
          });
        }
      } else {
        this.renderComp = false;
        this.$nextTick(() => {
          this.renderComp = true;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Please Enter The Code Sent To Registered Email",
          };
        });
      }
    },
    ConfirmOTPMethod() {
      Auth.forgotPasswordSubmit(this.OTPEmail, this.OTPInput, this.ConfirmNewPassword)
        .then(() => {
          this.renderComp = false;
          this.$nextTick(() => {
            this.renderComp = true;
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "green",
              Top: true,
              SnackbarText: "Password Changed Successfully  ",
            };
          });

          this.loginStepper = 1;
          this.$refs.confirmOTP.reset();
        })
        .catch((err) => {
          this.renderComp = false;
          this.$nextTick(() => {
            this.renderComp = true;
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "red",
              Top: true,
              SnackbarText: err.message,
            };
          });
        });
    },
  },
};
</script>
<style scoped>
.v-application .rounded-b1-x1 {
  border-bottom-left-radius: 300px !important;
}

.background {
  background: linear-gradient(45deg, #202b59, #35bc99);
}

.v-application .rounded-br-x1 {
  border-bottom-right-radius: 300px !important;
}

.title {
  color: #35bc99;
  font-size: 40px !important;
}
.heading0 {
  font-size: 35px !important;
  font-weight: bolder !important;
  line-height: 35px !important;
}
.heading6 {
  font-size: 16px !important;
}
.supportBtn {
  display: flex;
  align-items: center;
  justify-content: end;
}
.supportimage :hover {
  scale: 125%;
}
</style>
